module.exports = __webpack_public_path__ + "img/icon-change-payment-date.caae5c83.svg";